import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'era-edit-device-name-modal',
  templateUrl: './edit-device-name-modal.component.html',
  styleUrls: ['./edit-device-name-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [ReactiveFormsModule, FaIconComponent, NgbTooltip],
})
export class EditDeviceNameModalComponent implements OnInit {
  public renameForm?: UntypedFormGroup;
  @Input() public initialName: string | undefined;

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly formBuilder: UntypedFormBuilder
  ) {}

  ngOnInit(): void {
    this.renameForm = this.createForm();
  }

  private createForm(): UntypedFormGroup {
    return this.formBuilder.group({
      desiredName: [this.initialName ?? '', Validators.pattern(/^[a-zA-Z0-9\s-]{0,10}$/)],
    });
  }

  closeModal(): void {
    this.activeModal.dismiss();
  }

  save(): void {
    const result = {
      newName: this.renameForm.get('desiredName').value,
    } satisfies Result;
    this.activeModal.close(result);
  }
}

interface Result {
  newName: string;
}
